module.exports = __webpack_public_path__ + "img/jqr1.02cf764b.jpg";